/* iurop-appointment — selector de tienda custom + calendario INLINE de Cowlendar.
   Al elegir una tienda se inyecta <div data-cowlendar-inline="sid-vid">, que la app de
   Cowlendar hidrata como iframe (lo capta su MutationObserver). Si su app no respondiera
   en unos segundos, montamos el iframe de booking/embed a mano como red de seguridad. */
(function () {
  var COW_ORIGIN = 'https://widget.cowlendar.com';

  function shopDomain() {
    try {
      if (window._cowlendarConfig && window._cowlendarConfig.shop_url) return window._cowlendarConfig.shop_url;
      if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    } catch (e) {}
    return (location.hostname || '').replace(/^www\./, '');
  }

  function cowLocale() {
    try {
      if (typeof window._cowGetUserLocale === 'function') {
        var l = window._cowGetUserLocale();
        if (l) return l;
      }
    } catch (e) {}
    return (document.documentElement.lang || 'es').trim() || 'es';
  }

  function buildIframe(sid, vid) {
    var params = {
      shop: shopDomain(),
      sid: sid,
      qty: '1',
      mode: 'standalone-inline',
      locale: cowLocale()
    };
    if (vid) params.vid = vid;
    var qs = Object.keys(params).map(function (k) {
      return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
    }).join('&');
    var ifr = document.createElement('iframe');
    ifr.className = 'cowlendar-iframe iurop-appt__iframe';
    ifr.src = COW_ORIGIN + '/booking/embed?' + qs;
    ifr.setAttribute('width', '100%');
    ifr.setAttribute('frameborder', '0');
    ifr.setAttribute('allow', 'payment');
    ifr.setAttribute('title', 'Cowlendar');
    return ifr;
  }

  function init(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-appt-card]'));
    var noAvail = root.getAttribute('data-appt-no-avail') === 'true';
    var labelEl = root.querySelector('[data-appt-active-store]');

    // Modo sin disponibilidad: las tarjetas solo marcan activa + etiqueta, sin calendario.
    if (noAvail) {
      var setActive = function (card) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-active', on);
          c.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        if (labelEl) labelEl.textContent = card.getAttribute('data-name') || '';
      };
      cards.forEach(function (card) {
        card.addEventListener('click', function () { setActive(card); });
      });
      if (cards.length) setActive(root.querySelector('[data-appt-card][data-default="true"]') || cards[0]);
      return;
    }

    var panel = root.querySelector('[data-appt-calendar]');
    if (!panel) return;
    var fallbackTimer = null;

    function mountFallback(host, sid, vid) {
      // Si Cowlendar no ha inyectado su iframe, lo montamos nosotros.
      if (host.querySelector('iframe')) return;
      host.innerHTML = '';
      host.appendChild(buildIframe(sid, vid));
      root.classList.add('is-fallback');
    }

    function showCalendar(sid, vid, name) {
      if (fallbackTimer) { clearTimeout(fallbackTimer); fallbackTimer = null; }
      if (labelEl) labelEl.textContent = name || '';
      panel.innerHTML = '';

      var host = document.createElement('div');
      host.className = 'iurop-appt__cow';
      host.setAttribute('data-cowlendar-inline', vid ? (sid + '-' + vid) : sid);
      panel.appendChild(host);

      // La app de Cowlendar debería hidratar `host` (su MutationObserver ve el nuevo div).
      // Red de seguridad: si en 3.5s no hay iframe, lo montamos a mano.
      fallbackTimer = setTimeout(function () { mountFallback(host, sid, vid); }, 3500);

      if (window.matchMedia && window.matchMedia('(max-width:749px)').matches) {
        try { panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
      }
    }

    function select(card) {
      cards.forEach(function (c) {
        var active = c === card;
        c.classList.toggle('is-active', active);
        c.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      showCalendar(
        card.getAttribute('data-sid'),
        card.getAttribute('data-vid'),
        card.getAttribute('data-name')
      );
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { select(card); });
    });

    // Selección por defecto (primera tienda o la marcada). Si no hay tarjetas
    // (una sola tienda), usamos los datos del propio panel.
    if (cards.length) {
      var def = root.querySelector('[data-appt-card][data-default="true"]') || cards[0];
      select(def);
    } else {
      var loneSid = panel.getAttribute('data-sid');
      var loneVid = panel.getAttribute('data-vid');
      if (loneSid) showCalendar(loneSid, loneVid, '');
    }
  }

  function boot() {
    Array.prototype.slice.call(document.querySelectorAll('[data-iurop-appt]')).forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
